const { ENV: ENVIRONMENT, STAGE, CONFIG_BY_STAGE, DATADOG_CONFIG, VERSION } = window.__ENVIRONMENT__
const { AMPLITUDE_CONFIG } = CONFIG_BY_STAGE[STAGE]
const { API_HOST, FIREBASE_CONFIG } = CONFIG_BY_STAGE[STAGE].CONFIG_BY_ENV[ENVIRONMENT]

const THEME = window.__THEME__ || { stateShort: 'TAS' }

export { ENVIRONMENT, API_HOST, STAGE, FIREBASE_CONFIG, THEME, DATADOG_CONFIG, VERSION, AMPLITUDE_CONFIG }
